'use client';

import Button from '@/components/Button';
import SectionTitle from '@/components/SectionTitle';

import { useConfig } from '@/app/contexts/ConfigContext';
import { SERVICE_TYPES } from '@/helpers/enums';

// Only use for FR portals for now
export default function DownloadSection() {
  const { config } = useConfig();

  const handleDownload = () => {
    let zipUrl = '';
    let baseName = 'contenu';

    switch (config.serviceType) {
      case SERVICE_TYPES.FITNESS:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/fitness/download/fitness-videos.zip';
        baseName = 'fitness-videos';
        break;
      case SERVICE_TYPES.YOGA:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/yoga/download/yoga-videos.zip';
        baseName = 'yoga-videos';
        break;
      case SERVICE_TYPES.PILATES:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/pilates/download/pilates-videos.zip';
        baseName = 'pilates-videos';
        break;
      case SERVICE_TYPES.MEDITATION:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/meditation/download/meditation-audios.zip';
        baseName = 'meditation-audios';
        break;
      case SERVICE_TYPES.ASTROLOGY:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/astrology/download/astrology-audios.zip';
        baseName = 'astrology-audios';
        break;
      case SERVICE_TYPES.LOVE:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/love/download/love-audios.zip';
        baseName = 'love-audios';
        break;
      case SERVICE_TYPES.COOKING:
        zipUrl =
          'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices/cooking/download/cooking-videos.zip';
        baseName = 'cooking-videos';
        break;
      default:
        zipUrl = '';
    }

    if (!zipUrl) return;

    const content =
      `Téléchargez vos contenus dès maintenant en cliquant sur ce lien :\n` +
      `${zipUrl}\n\n`;

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const objectUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = `${baseName}-lien.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(objectUrl);
  };

  return (
    <section className='sm:mt-16 mt-8'>
      <SectionTitle>téléchargez tous vos contenus ici:</SectionTitle>
      <div className='flex items-end justify-between items-center mt-4'>
        <Button
          variant='secondary'
          className='!px-5'
          themeBackgroundColor={config.theme.textColorDark}
          themeTextColor={config.theme.textColorLight}
          onClick={handleDownload}
        >
          Télécharger
        </Button>
      </div>
    </section>
  );
}
